import { useEffect, useState } from 'react';
import directorImage from '../assets/belowBanner/director.jpeg';
import principalImage from '../assets/belowBanner/principal.jpeg';
import coordinatorImage from '../assets/belowBanner/coordinator.jpeg';

const events = [
  { title: 'Science Exhibition Science Exhibition Science Exhibition', date: 'Oct 15' },
  { title: 'Annual Sports Day', date: 'Nov 10' },
  { title: 'Parent-Teacher Meeting', date: 'Nov 22' },
  { title: 'Annual Cultural Day', date: 'Dec 08' }
];

const eventsPerSlide = 2;
const totalEventSlides = Math.ceil(events.length / eventsPerSlide);

const news = [
  "Principal's Message for New Term",
  'Library Renovation Complete',
  'Inter-School Debate Winner',
];

const leaders = [
  { image: principalImage, title: 'Principal', text: ' Mr. Yogesh Giri- Leading our school with care, purpose, and a commitment to every learner.' },
  { image: directorImage, title: 'Director', text: 'Mr. Dinesh Gawla- Supporting teachers and students through thoughtful academic leadership.' },
  { image: coordinatorImage, title: 'Coordinator', text: 'Mr. Sunil Jirati- Connecting educators, students, and families to build an engaging and organized school community.' },
];

const schoolValues = [
  {
    title: 'Established since 1988',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
      </svg>
    )
  },
  {
    title: 'Nursery to Class 12 education',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
      </svg>
    )
  },
  {
    title: 'Modern facilities',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M3 21h18M5 21V7l8-4v18M13 10h4v11" />
      </svg>
    )
  },
  {
    title: 'Community and values-led learning',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    )
  }
];

function BelowBannerSection() {
  const [eventSlide, setEventSlide] = useState(0);

  useEffect(() => {
    const rotation = window.setInterval(() => {
      setEventSlide((currentSlide) => (currentSlide + 1) % totalEventSlides);
    }, 4500);

    return () => window.clearInterval(rotation);
  }, []);

  const visibleEvents = events.slice(
    eventSlide * eventsPerSlide,
    eventSlide * eventsPerSlide + eventsPerSlide,
  );

  const showPreviousEvents = () => {
    setEventSlide((currentSlide) => (currentSlide - 1 + totalEventSlides) % totalEventSlides);
  };

  const showNextEvents = () => {
    setEventSlide((currentSlide) => (currentSlide + 1) % totalEventSlides);
  };

  return (
    <section className="below-banner" id="campus-updates" aria-label="Campus events and school updates">
      <div className="below-banner-inner">
        <div className="updates-topline">
          <div className="event-row" aria-label="Upcoming events">
            <button className="event-arrow" type="button" aria-label="Previous events" onClick={showPreviousEvents}>‹</button>
            <div className="event-cards">
              {visibleEvents.map((event) => (
                <article className="event-card" key={event.title}>
                  <h3>{event.title}</h3>
                  <p>{event.date}</p>
                </article>
              ))}
            </div>
            <button className="event-arrow" type="button" aria-label="Next events" onClick={showNextEvents}>›</button>
            <div className="event-dots" aria-label="Choose event slide">
              {Array.from({ length: totalEventSlides }, (_, index) => (
                <button
                  className={index === eventSlide ? 'is-active' : ''}
                  type="button"
                  aria-label={`Show event slide ${index + 1}`}
                  aria-current={index === eventSlide ? 'true' : undefined}
                  key={index}
                  onClick={() => setEventSlide(index)}
                />
              ))}
            </div>
          </div>
          <aside className="school-news" aria-labelledby="school-news-title">
            <h2 id="school-news-title">School News</h2>
            <div className="school-news-list">
              {news.map((item) => <a href="#campus-updates" key={item}>{item}</a>)}
            </div>
          </aside>
        </div>

        <div className="below-banner-columns" id="school-values">
          <section className="news-summary" aria-labelledby="school-values-title">
            <h2 id="school-values-title">Our Pillars</h2>
            <ul className="school-values-list">
              {schoolValues.map((value) => (
                <li key={value.title} className="school-value-item">
                  <span className="value-icon">{value.icon}</span>
                  <span className="value-text">{value.title}</span>
                </li>
              ))}
            </ul>
            <a className="text-link" href="#about">Learn more about us <span aria-hidden="true">→</span></a>
          </section>
          <section className="leadership-section">
            <div className="leader-grid">
              {leaders.map((leader) => (
                <article className="leader-card" key={leader.title}>
                  <img src={leader.image} alt={leader.title} />
                  <h3>{leader.title}</h3>
                  <p>{leader.text}</p>
                </article>
              ))}
            </div>
          </section>
        </div>

      </div>
    </section>
  );
}

export default BelowBannerSection;